module.exports = __webpack_public_path__ + "img/file-pdf.5e9d9d0b.svg";